import snakeCase from 'lodash/snakeCase';

export default function parseApiErrorsToFormik(errors) {
  let result = {};

  for (let key in errors) result[snakeCase(key)] = errors[key][0];

  return result;
}
